module.exports = __webpack_public_path__ + "img/graded.cf442950.png";